<div class="filter-item">
  <a mat-button class="primary-menu-button" [matMenuTriggerFor]="propertyFeaturesFilter">
    <span class="pr-2" [class.primary-color]="propertyFeatureSelected">{{ menuLabel }}</span>
    <mat-icon iconPositionEnd class="menu-expand-icon">arrow_drop_down</mat-icon>
  </a>
  <mat-menu #propertyFeaturesFilter="matMenu" (closed)="onMenuClosed($event)">
    <div>
      <div class="ml-3 mb-2"><b>Property Features</b></div>
      <form [formGroup]="propertyFeaturesForm" class="mx-3">
        <div class="flex-col">
          <mat-form-field (click)="$event.stopPropagation()">
            <mat-label>Beds</mat-label>
            <mat-select formControlName="beds">
              @for (value of bedRoomFilterValues; track value) {
                <mat-option [value]="value">
                  {{ value.label }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field (click)="$event.stopPropagation()">
            <mat-label>Baths</mat-label>
            <mat-select formControlName="baths">
              @for (value of bathRoomFilterValues; track value) {
                <mat-option [value]="value">
                  {{ value.label }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field (click)="$event.stopPropagation()">
            <mat-label>Garages</mat-label>
            <mat-select formControlName="garages">
              @for (value of garageFilterValues; track value) {
                <mat-option [value]="value">
                  {{ value.label }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <div class="flex-row space-between items-center w-100">
            <mat-form-field class="w-45" (click)="$event.stopPropagation()">
              <mat-label>Sqft Min</mat-label>
              <input matInput autocomplete="off" formControlName="areaFrom" type="text" onlyNumber>
            </mat-form-field>
            <mat-form-field class="w-45" (click)="$event.stopPropagation()">
              <mat-label>Sqft Max</mat-label>
              <input matInput autocomplete="off" formControlName="areaTo" type="text" onlyNumber>
            </mat-form-field>
          </div>
        </div>
      </form>
    </div>
    <div class="flex-row space-between items-center px-2 py-2 sticky">
      <a color="primary" mat-button (click)="onClearClick()">Clear</a>
      <button mat-flat-button color="primary" mat-button (click)="onApplyClick()">Apply</button>
    </div>
  </mat-menu>
</div>